import { render } from "./TransportOrderModal.vue?vue&type=template&id=04e23591&scoped=true"
import script from "./TransportOrderModal.vue?vue&type=script&lang=js"
export * from "./TransportOrderModal.vue?vue&type=script&lang=js"

import "./TransportOrderModal.vue?vue&type=style&index=0&id=04e23591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e23591"]])

export default __exports__